const labelCls = 'block text-xs font-mono uppercase tracking-wider text-yunti-ink/70 mb-1';
const inputCls =
  'w-full px-3 py-2.5 bg-white border border-yunti-ink/20 text-sm focus:border-yunti-purple focus:outline-none rounded-none';

export function Field({ label, value, onChange, placeholder, testId }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <input
        type="text"
        className={inputCls}
        value={value ?? ''}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
      />
    </div>
  );
}

export function Area({ label, value, onChange, rows = 4, hint, testId }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <textarea
        className={inputCls}
        rows={rows}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
      />
      {hint && <p className="text-[11px] text-yunti-ink/50 mt-1">{hint}</p>}
    </div>
  );
}

export function SelectField({ label, value, onChange, options, testId }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <select
        className={inputCls}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export function ColorField({ label, value, onChange, testId }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <div className="flex items-center gap-3">
        <input
          type="color"
          className="w-12 h-10 border border-yunti-ink/20 rounded-none cursor-pointer bg-white"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testId}
        />
        <input
          type="text"
          className={`${inputCls} w-28 font-mono`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={`${testId}-hex`}
        />
      </div>
    </div>
  );
}

export function Card({ title, hint, children }) {
  return (
    <div className="bg-white border border-yunti-ink/10 p-6 space-y-4">
      <div>
        <h3 className="font-display uppercase tracking-tight text-lg text-yunti-ink">{title}</h3>
        {hint && <p className="text-xs text-yunti-ink/50 mt-1">{hint}</p>}
      </div>
      {children}
    </div>
  );
}
